import React from 'react';
import Utils from '../../utils/Validate'
 
const InputFile = ({name, value,placeholder,alias,onChange, onBlur, validate,  
      disabled, clase = undefined, ismap = undefined, mensajeError, defaultUrl, textButton}) =>
  <div style={{display:'flex  '}}>
    <div className={(clase || '')+" input-field"} >
      <input 
      id={placeholder+'_url'} 
      className= {"no-borders-right validate " + (validate === false ? 'input-error' : '') + (disabled ? 'disabled' : '') }
      value={(value)?value:defaultUrl}
      type="text"/>
      <label className={'active '} htmlFor={ismap ? ismap : placeholder+'_url'}>{placeholder}</label>
      {(validate === false) ? <span className="message-error">* Seleccione un(a) {Utils.convertirMinusculas(alias || placeholder)} válido(a) </span> : null} 
    </div>      
    <label className={'btn-small botonFormulario '+(disabled? 'disabled ': '')} htmlFor={placeholder} style={{ width:"40%", borderTopLeftRadius: 0, borderBottomLeftRadius: 0, height: 45}}>
          {textButton}           
    </label>
    <input
        id={placeholder}
        type="file"
        name={name}
        value={(value)?value:''}
        disabled={disabled}                    
        onChange = { (e) => { onChange(e) }}
        onBlur={ (e) => onBlur(e) }
        style={{display:"none"}}            
        />        
	</div>

export default InputFile;